import type { ReactNode } from 'react';
import { Eye } from 'lucide-react';
import { Modal } from './Modal.js';
import { Button } from './Button.js';

interface DetailViewModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

export function DetailViewModal({
  open,
  onClose,
  title,
  children,
  size = 'lg',
}: DetailViewModalProps) {
  return (
    <Modal open={open} onClose={onClose} title={title} size={size}>
      <dl className="space-y-4">{children}</dl>
      <div className="mt-6 flex justify-end border-t border-slate-100 pt-4 dark:border-slate-800">
        <Button variant="secondary" onClick={onClose}>Close</Button>
      </div>
    </Modal>
  );
}

export function DetailField({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div>
      <dt className="text-xs font-medium text-slate-400 dark:text-slate-500">
        {label}
      </dt>
      <dd className="mt-1 whitespace-pre-wrap text-sm text-slate-800 dark:text-slate-200">
        {children}
      </dd>
    </div>
  );
}

export function ViewRecordButton({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) {
  return (
    <Button
      size="sm"
      variant="ghost"
      aria-label={`View ${label}`}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <Eye className="h-4 w-4" />
    </Button>
  );
}
